<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout class="notPrinted">
                    <v-flex xs12>
                        <h1 class="text-xs-center">Previous Order Details</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 v-if="loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                    <v-flex xs12 v-if="!loading && loadError">
                        <v-card>
                            <v-alert outline :value="true" color="error" icon="error">
                                {{loadError}}
                            </v-alert>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3 v-if="!loading && !loadError">
                        <v-layout wrap>
                            <v-flex xs6 md6 class="notPrinted">
                                <v-text-field
                                    v-model="selectedOrder.ID"
                                    :readonly="true"
                                    label="Order Number">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6 md6>
                                <v-text-field
                                    v-model="selectedOrder.FormattedDate"
                                    :readonly="true"
                                    label="Date of Order">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6 md6>
                                <v-text-field
                                    v-model="selectedOrder.StoreName"
                                    :readonly="true"
                                    label="Store">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6 md6 class="notPrinted">
                                <v-text-field
                                    v-model="selectedOrder.DepartmentName"
                                    :readonly="true"
                                    label="Department">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="notPrinted">
                                <v-text-field
                                    v-model="selectedOrder.SentByEmail"
                                    :readonly="true"
                                    label="Order Sent By">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="notPrinted">
                                <v-text-field
                                    v-model="selectedOrder.FormattedSentDate"
                                    :readonly="true"
                                    label="Date Order Sent">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <PrintableOrderSummary
                                    :loading="loading"
                                    :ordersProducts="ordersProductsWithSuppliers"
                                    :allowEmailResend="selectedOrder.Stage >= 3"
                                    v-model="resendEmails">
                                </PrintableOrderSummary>
                            </v-flex>
                        </v-layout>   
                        <v-layout wrap class="dialog-action-buttons notPrinted">
                            <v-flex xs12 md4>
                                <v-btn block color="info" @click="cancelViewDetailsOrder">{{ backButtonText }}</v-btn>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-btn block color="info" @click="triggerPrint">Print</v-btn>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-btn v-if="selectedOrder.Stage >= 3" block color="success" :loading="sendingEmails" @click="triggerResendEmails" :disabled="!resendSelected">Resend Email(s)</v-btn>
                            </v-flex>
                        </v-layout>                       
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-dialog v-model="showConfirmDialog" transition="dialog-transition" max-width="300px">
                <v-card class="no-padding">
                    <v-card-title class="headline">Resend Emails</v-card-title>
                    <v-card-text>Emails for selected suppliers have been successfully sent.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="info" @click="showConfirmDialog = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import PrintableOrderSummary from './PrintableOrderSummary';
import api from '../../services/api';

export default {
    components: {
        PrintableOrderSummary
    },
    props: [
        'orderID',
        'backRouteName'
    ],
    data() {
        return {
            orderLoading: false,
            orderError: false,
            selectedOrder: {},
            ordersProductsWithSuppliers: [],
            resendEmails: {},
            showConfirmDialog: false,
            sendingEmails: false
        };
    },
    computed: {
        loading(){
            return this.orderLoading
                || this.$store.state.orderStore.products.loading
                || this.$store.state.supplierStore.loading;
        },
        loadError(){
            return this.orderError
                || this.$store.state.orderStore.products.loadError
                || this.$store.state.supplierStore.loadError;
        },
        ordersProducts(){
            return this.$store.state.orderStore.products.ordersProducts.sort(function(a, b) {
                if (a.SupplierName < b.SupplierName) {
                    return -1;
                }
                else if (a.SupplierName > b.SupplierName) {
                    return 1;
                }

                return 0;
            });
        },
        suppliers(){
            return this.$store.state.supplierStore.suppliers.filter(c => c.Active);
        },
        backButtonText(){
            if(this.backRouteName == "home"){
                return "Home";
            }

            if(this.backRouteName == "previousorders"){
                return "Previous Orders";
            }

            return this.backRouteName;
        },
        resendSelected() {
            for(var key in this.resendEmails) {
                if(this.resendEmails[key].resendEmail == true)
                    return true;
            }

            return false;
        }
    },
    methods: {
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        },
        loadOrder(){
            let that = this;
            that.orderLoading = true;
            this.$store.dispatch("placeOrderStore/loadOrder", this.orderID).then((order) => {
                that.selectedOrder = Object.assign({
                    get FormattedDate(){
                        return that.formatDate(this.Date);
                    },
                    get FormattedSentDate(){
                        return that.formatDateTime(this.SentDate);
                    }
                }, order);
                that.orderLoading = false;
            }).catch((err) => {
                that.orderLoading = false;
                that.orderError = true;
            });
        },
        loadOrdersProducts(){
            let that = this;
            that.ordersProductsWithSuppliers = [];
            this.$store.dispatch("orderStore/loadOrdersProducts", {
                orderID: this.orderID,
                success: (res) => {
                    that.ordersProductsWithSuppliers = that.getOrdersProductsWithSuppliers();
                }
            });
        },
        formatDate(dateString){
            let date = new Date(dateString);

            let day = date.getDate() + "";
            if(day.length == 1){
                day = "0" + day;
            }
            let month = date.getMonth() + 1 + "";
            if(month.length == 1){
                month = "0" + month;
            }
            let year = date.getFullYear();

            return day + "/" + month + "/" + year;
        },
        formatDateTime(dateTimeString){
            let date = new Date(dateTimeString);

            let day = date.getDate() + "";
            if(day.length == 1){
                day = "0" + day;
            }
            let month = date.getMonth() + 1 + "";
            if(month.length == 1){
                month = "0" + month;
            }
            let year = date.getFullYear();

            let hour = date.getHours() + "";
            if(hour.length == 1){
                hour = "0" + hour;
            }
            let minute = date.getMinutes() + "";
            if(minute.length == 1){
                minute = "0" + minute;
            }
            let second = date.getSeconds() + "";
            if(second.length == 1){
                second = "0" + second;
            }

            return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
        },
        getOrdersProductsWithSuppliers(){
            let that = this;

            return this.ordersProducts.map(oP => {
                let ordersProduct = Object.assign({}, oP);

                let supplier = that.suppliers.find(s => s.ID == ordersProduct.SupplierID);
                if(supplier != null){
                    ordersProduct.Supplier = supplier;
                }

                return ordersProduct;
            }).filter(oP => oP.Supplier != null);
        },
        triggerPrint(){
            window.print();
        },
        cancelViewDetailsOrder(){
            this.$router.push({
                name: this.backRouteName
            });
        },
        triggerResendEmails() {
            this.sendingEmails = true;
            let supplierIDs = [];

            for (var supplierID in this.resendEmails) {
                // check if the property/key is defined in the object itself, not in parent
                if (this.resendEmails.hasOwnProperty(supplierID) && this.resendEmails[supplierID].resendEmail == true) {                    
                    supplierIDs.push(parseInt(supplierID));
                }
            }

            let that = this;

            api.resendSupplierEmails(this.orderID, supplierIDs, {
                success: (resp) => {
                    that.showConfirmDialog = true;
                    that.sendingEmails = false;
                    that.resendEmails = {};
                }
            });            
        }
    },
    created(){
        this.loadSuppliers();
        this.loadOrder();
        this.loadOrdersProducts();
    }
};
</script>

<style>

</style>